import { tabsBenefistsItems } from '../../../data/data';
import { useState } from 'react';
import { ClassNameProps, Item } from '../../../types/types';

const TabsBenefists = ({ className }: ClassNameProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleTabClick = (index: number) => {
    setActiveTabIndex(index);
  };

  return (
    <div className={className}>
      <div className={`${className}__nav`}>
        {tabsBenefistsItems.map((tab: Item, index: number) => (
          <div key={tab.id} className={`${className}__info`}>
            <button
              key={tab.id}
              className={`${className}__item ${
                activeTabIndex === index ? `${className}__item--active` : ''
              }`}
              onClick={() => handleTabClick(index)}
            >
              <span className={`${className}__number text-micro`}>
                0{tab.id}.
              </span>
              <span className={`${className}__text subtitle`}>
                {activeTabIndex === index
                  ? tab.activeTitle ?? tab.title
                  : tab.title}
              </span>
            </button>
            <div
              className={`${className}__content text-small ${
                activeTabIndex === index ? `active` : ''
              }`}
            >
              {tab.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabsBenefists;
